import { Component, OnInit } from '@angular/core';
import {ModalExtended} from 'ngx-dynamic-modal';
import {VnaCallerIdService} from '../../services/vna-caller-id.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AlertaService} from '../../../../../shared/services/alerta.service';
import {AuthService} from '../../../../../core/service/auth.service';
import * as moment from 'moment';
import {DatesParserService} from '../../../../../core/service/dates_parser.service';

@Component({
  selector: 'app-vna-caller-id-edit',
  templateUrl: './vna-caller-id-edit.component.html',
  styleUrls: ['./vna-caller-id-edit.component.scss']
})
export class VnaCallerIdEditComponent extends ModalExtended implements OnInit {

    data: Object;
    form: FormGroup;
    submitted: boolean = false;
    loading: boolean = false;

    errors: Object = {};

    constructor(private callerIdService: VnaCallerIdService, private fb: FormBuilder, private alertService: AlertaService, private auth: AuthService, private datesParser: DatesParserService) {
        super();

        this.form = this.fb.group({
            'number': new FormControl('', Validators.required),
            'price': new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d+)?$/)]),
            'setup': new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d+)?$/)]),
            'source' : new FormControl('', Validators.required),
            'bought_at' : new FormControl('', Validators.required),
            'service_campaign_verification_pk' : new FormControl(),
            'description' : new FormControl(),
            'vna_client_pk' : new FormControl()
        });
    }

    onExit(): void {
        this.applyCallback(true);
        this.close();
    }

    ngOnInit() {
        if(this.data.hasOwnProperty('object')){
            this.form.controls['number'].setValue(this.data['object']['number']);
            this.form.controls['price'].setValue(this.data['object']['price']);
            this.form.controls['setup'].setValue(this.data['object']['setup']);
            this.form.controls['source'].setValue(this.data['object']['source']);
            this.form.controls['bought_at'].setValue(this.data['object']['bought_at']);
            this.form.controls['description'].setValue(this.data['object']['description']);
            this.form.controls['service_campaign_verification_pk'].setValue(this.data['object']['service_campaign_verification_pk']);
            this.form.controls['vna_client_pk'].setValue(this.data['object']['vna_client_pk'])
        }
    }

    createCallerId(): void {

        if(!this.form.valid){
            this.submitted = true;
            return;
        }

        this.errors = {};
        this.loading = true;
        let data = this.datesParser.cleanDates(this.form.value, ['bought_at'], false);
        data['portal_pk'] = this.auth.getPkPortal();

        this.callerIdService.createCallerId(data).subscribe(
            (r: Object) => {
                (r['status'] == 'KO')
                    ? this.errors = r['errors']
                    : this.alertService.addAlert('success', 'Caller Id with number ' + this.form.value.number + ' has been created successfully')
                ;

                this.loading = false;
            }
        )
    }

    updateCallerId(): void {
        this.errors = {};
        if(!this.form.valid){
            this.submitted = true;
            return;
        }

        this.loading = true;
        let data = this.datesParser.cleanDates(this.form.value, ['bought_at'], false);
        this.callerIdService.updateCallerId(this.data['object']['pk'], data).subscribe(
            (r: Object) => {
                this.alertService.addAlert('success', 'Caller Id with number ' + this.form.value.number + ' has been updated successfully');
                this.loading = false;
            }
        )
    }
}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/caller-id/modals/vna-caller-id-edit/vna-caller-id-edit.component.ts